import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientsApiAdapter } from '../../List/adapters/ClientsApiAdapter';

export const useClient = (clientId: number) => {
    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientsApiAdapter(httpClient);
    }, []);

    const { data: client, isLoading, error, refetch } = useQuery({
        queryKey: ['client', clientId],
        queryFn: async () => {
            return apiAdapter.getClientById(clientId);
        },
        staleTime: 2 * 60 * 1000, // 2 minutos
        enabled: !!clientId,
    });

    return {
        client,
        isLoading,
        error,
        refetch,
    };
};

